import type { EntityKey, EntityObject } from '../public-types';

export class Record<TEntity extends EntityObject = EntityObject> {
  data: TEntity;
  id: string;
  type: string;

  constructor(id: string, type: string, data: TEntity) {
    this.id = id;
    this.type = type;
    this.data = data;

    this.setValue = this.setValue.bind(this);
    this.getValue = this.getValue.bind(this);
    this.setData = this.setData.bind(this);
    this.getData = this.getData.bind(this);
  }

  setValue<TKey extends keyof TEntity>(key: TKey, value: TEntity[TKey]) {
    this.data = { ...this.data, [key]: value };
  }

  getValue<TKey extends keyof TEntity>(key: TKey) {
    return this.data[key];
  }

  setData(data: Partial<TEntity>) {
    this.data = { ...this.data, ...data };
  }

  getData() {
    return this.data;
  }
}

export type RecordIdentifier = EntityKey;
